import { Company } from './company';
import { CompanyImplementationData } from '../analysis/company-implementation-data';
import { OfferStatus } from './offer-status.enum';

export class CompanyWithOffer {

  constructor(
    public company: Company,
    public implementationCompanyData?: CompanyImplementationData,
  ) {
    if (!implementationCompanyData) {
      this.implementationCompanyData = {
        companyId: company.companyId,
        offerAmount: null,
        offerStatus: OfferStatus.WAITING,
      };
    }
  }
}
